import {AverageRating} from "./average-rating";

export class SurveyAverageRatingValueConverter extends AverageRating {
    toView(value) {
        return super._getAverageRating(value);
    }
}
